import React from 'react';

import Paper from '@material-ui/core/Paper';

import classes from './EsmsCard.module.css';

const esmsCard = props => {
    return (
        <Paper className={props.expandCard ? `${classes.esmsCardContainer} ${classes.expandCard}` : `${classes.esmsCardContainer}`}>
            <h2>{props.title}</h2>
            <div className={classes.esmsCardImage}>
                <img src={props.imagePath} alt="card flavor" />
            </div>
            <div className={classes.esmsCardContents}>
                {props.children}
            </div>
        </Paper>
    );
};

export default esmsCard;
